import React, { useState } from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { businessInfo, heroImage } from '../data/mock';
import { BookingFlow } from './booking/BookingFlow';

export const Hero = () => {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-white" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Blue Porsche 718 freshly detailed"
          className="w-full h-full object-cover object-[70%_center]"
          data-testid="hero-image"
        />
        <div className="absolute inset-0 bg-white/75 md:bg-transparent md:bg-gradient-to-r md:from-white md:from-15% md:via-white/60 md:via-40% md:to-transparent md:to-65%"></div>
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-white to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pt-28 pb-20">
        <div className="max-w-2xl animate-fade-in">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-[3px] w-10 bg-red-600 -skew-x-12"></span>
            <span className="font-display uppercase tracking-[0.12em] md:tracking-[0.25em] text-xs md:text-sm font-semibold text-red-600" data-testid="hero-eyebrow">
              Mobile Detailing • {businessInfo.serviceArea}
            </span>
          </div>
          <h1 className="font-display italic uppercase text-5xl sm:text-6xl lg:text-7xl font-extrabold text-neutral-950 mb-6 leading-[0.95] tracking-tight">
            Precision.<br />Protection.<br /><span className="text-red-600">Perfection.</span>
          </h1>
          <p className="text-base md:text-lg text-neutral-700 mb-10 max-w-xl">
            Premium mobile detailing in {businessInfo.serviceArea}. We bring the shop to your driveway.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              type="button"
              onClick={() => setBookingOpen(true)}
              data-testid="hero-book-now-btn"
              className="group px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-display uppercase tracking-wider text-lg font-bold rounded-sm flex items-center justify-center gap-2 shadow-lg shadow-red-600/25 hover:-translate-y-0.5"
            >
              <span>Book Now</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              type="button"
              onClick={() => document.getElementById('quote').scrollIntoView({ behavior: 'smooth' })}
              data-testid="hero-get-quote-btn"
              className="px-8 py-4 bg-neutral-950 hover:bg-neutral-800 text-white font-display uppercase tracking-wider text-lg font-bold rounded-sm hover:-translate-y-0.5"
            >
              Get a Quote
            </button>
          </div>

          <a
            href={`tel:${businessInfo.phone}`}
            data-testid="hero-phone-link"
            className="mt-8 inline-flex items-center gap-2 text-neutral-800 hover:text-red-600 font-semibold"
          >
            <Phone className="w-4 h-4 text-red-600" />
            {businessInfo.phone}
          </a>
        </div>
      </div>
      <BookingFlow open={bookingOpen} onClose={() => setBookingOpen(false)} serviceName={null} />
    </section>
  );
};
